export const configuratorProps = {
  toolbarAdaptive: false,
  disablePlugins: ['imageProperties'],
  uploader: {
    insertImageAsBase64URI: true,
  },
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  language: 'pt_br',
  defaultMode: '1',
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  buttons: [
    // 'source',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'ul',
    'ol',
    '|',
    // 'outdent',
    // 'indent',
    // '|',
    // 'font',
    'fontsize',
    'brush',
    '|',
    // 'image',
    'table',
    // 'link',
    '|',
    'align',
    // 'undo',
    // 'redo',
    '|',
    'hr',
    'eraser',
    // 'copyformat',
    '|',
    'selectall',
  ],
};
